import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";

function ArrowPanel({ panel, event, label }) {
  return (
    <div style={{ display: "flex", alignItems: "center" }}>
      <label className="custom-label-qstn" htmlFor="headerCheckbox" style={{ marginRight: "4px" }}>
        {label}
      </label>
      {panel ? (
        <ArrowDropUpIcon
          style={{ fontSize: 28, cursor: "pointer" }}
          onClick={() => {
            event(false);
          }}
        />
      ) : (
        <ArrowDropDownIcon
          style={{ fontSize: 28, cursor: "pointer" }}
          onClick={() => {
            event(true);
          }}
        />
      )}
    </div>
  );
}

export default ArrowPanel;
